import React from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Link } from "react-router-dom";
import { ImmLogo } from "../../assets/images/logoImm";
import { tanzaniaLogo } from "../../assets/images/tanzaniaLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { getAppId } from "../../utility/Common";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PdfFromDocument = () => {
  const generatePDF = async () => {
    const docDefinition = {
      pageSize: { width: 595.28, height: 297.5 },
      content: [
        /*============A:PERSONAL DETAILS==============*/
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["*"],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          table: {
                            widths: ["20%", "*", "20%"],
                            body: [
                              [
                                {
                                  border: [false, false, false, false],
                                  stack: [
                                    {
                                      image:
                                        "data:image/jpeg;base64," +
                                        tanzaniaLogo,
                                      width: 60,
                                      height: 60,
                                      alignment: "left",
                                    },
                                  ],
                                },
                                {
                                  border: [false, false, false, false],
                                  table: {
                                    widths: ["*"],
                                    body: [
                                      [
                                        {
                                          border: [false, false, false, false],
                                          text: "JAMUHURI YA MUUNGANO WA TANZANIA",
                                          fontSize: 13,
                                          alignment: "center",
                                          bold: true,
                                        },
                                      ],
                                      [
                                        {
                                          border: [false, false, false, false],
                                          text: "WIZARA YA MAMBO YA NDANI",
                                          fontSize: 12,
                                          alignment: "center",
                                          bold: true,
                                        },
                                      ],
                                      [
                                        {
                                          border: [false, false, false, false],
                                          text: "IDARA YA UHAMIAJI",
                                          fontSize: 12,
                                          alignment: "center",
                                          bold: true,
                                        },
                                      ],
                                    ],
                                  },
                                },
                                {
                                  border: [false, false, false, false],
                                  stack: [
                                    {
                                      image:
                                        "data:image/jpeg;base64," +
                                        ImmLogo.logo,
                                      width: 60,
                                      height: 60,
                                      alignment: "right",
                                    },
                                  ],
                                },
                              ],
                            ],
                          },
                        },
                      ],
                    ],
                  },
                },
              ],
              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["*"],
                    body: [
                      [
                        {
                          border: [false, true, false, false],
                          text: "",
                          fontSize: 14,
                          bold: true,
                          decorationStyle: "dotted",
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
              ],

              [
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ["*"],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          table: {
                            widths: ["80%", "*"],
                            body: [
                              [
                                {
                                  border: [false, false, false, false],
                                  text: `Nambari yako ya utambulisho ni :`,
                                  fontSize: 12,
                                  alignment: "right",
                                  marginTop: 6,
                                  bold: true,
                                },
                                {
                                  border: [false, false, false, false],
                                  text: `${getAppId()?.toUpperCase()}`,
                                  fontSize: 11,
                                  alignment: "left",
                                  marginTop: 6,
                                },
                              ],
                            ],
                          },
                        },
                      ],
                    ],
                  },
                },
              ],
            ],
          },
        },
      ],
    };
    pdfMake.createPdf(docDefinition).download("Nambari ya Ombi.pdf");
  };

  return (
    <div>
      <button
        onClick={generatePDF}
        className="btn btn-info btn-label-next pull-left"
      >
        Pakua <FontAwesomeIcon icon={faFilePdf} />{" "}
      </button>
    </div>
  );
};

export default PdfFromDocument;
